"use client";

export function replaceBrowserUrlPreservingHistoryState(url: string) {
  if (typeof window === "undefined") return;

  window.history.replaceState(window.history.state, "", url);
}
